export const getObjectCenterCoordinates = (obj) => {
  const x = obj.left + (obj.width * obj.scaleX) / 2;
  const y = obj.top + (obj.height * obj.scaleY) / 2;

  return { x, y };
};
